<template>
  <page-wrap>
    <vehicle-manage-panel source="jws" :use-jws-api="true" show-person-code />
  </page-wrap>
</template>

<script>
import PageWrap from '../components/PageWrap'
import VehicleManagePanel from '../components/VehicleManagePanel'

export default {
  name: 'CheliangJwsManage',
  components: { PageWrap, VehicleManagePanel }
}
</script>
